import React, { Component } from 'react';
import {
    Route,
    Redirect,
    Switch,
} from 'react-router-dom';
import { connect } from 'react-redux';
import { isEmpty, get, isEqual } from 'lodash';
import asyncRoute from '../../helpers/hoc/asyncRoute';
import routes from '../../routes';
import { getFilterListAction } from '../../actions';
import './Dashboard.scss';
import { PrivateRoute } from '../../utils/route-auth';
import { MODULE_PERMISSIONS } from '../../constants/permission';
import { useCurrentPlanData } from '../../hooks/useCurrentPlanData'

const DashboardReport = asyncRoute(() => import('./FirstScreen/index'));

// const Card = asyncRoute(() => import('../../components/Card'));
// const BreadCrumb = asyncRoute(() => import('../../components/BreadCrumb'));
// const Tabs = asyncRoute(() => import('../../components/Tabs'));



const Dashboard = (props) => {

    const currentPlanData = useCurrentPlanData();

    // render() {
    const { match } = props;
    return (
        <div className="main-panel dashboard">
            <div className="content-wrapper">
                {/* <BreadCrumb /> */}
                <div className="row">
                    {/* <Card> */}
                    {/* <Tabs
                                container="dashboard"
                                isSecondaryPresent={true}
                            /> */}
                    <Switch>
                        {/* <Route exact path={`${match.path}`} render={() => <Redirect to={`${match.path}/${routes.containers.dashboard}`} />} />

                            <PrivateRoute path={`${match.path}/${routes.containers.dashboard}`} component={DashboardReport}
                                permissions={MODULE_PERMISSIONS.DASHBOARD}
                                defaultRoute={'dashboard'}
                            /> */}

                        <Route exact path={`${match.path}`} render={() =>
                            <DashboardReport match={match} {...props} />
                        }
                        />
                    </Switch>
                    {/* </Card> */}
                </div>
            </div>
        </div>
    );
    // }
}

export default connect(
    state => ({
        paymentAccess: get(state, 'app.paymentAccess.response', {}),
        filterList: get(state, 'app.filterList.response', {}),
        tenantId: get(state, 'app.preSignInState.tenantId', ''),
        userId: get(state, 'app.preSignInData.userId', ''),
        authToken: get(state, 'app.signInData.authToken', '')
    }),
    {
        getFilterListAction,
    }
)(Dashboard);
